const Profile = () => <div><h2>Profile</h2><p>User profile settings here</p></div>
export default Profile